import styled from 'styled-components'

export const Loading = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99999999;

  background-color: rgba(255, 255, 255, .74);
  backdrop-filter: blur(8px);
  opacity: 0;
  pointer-events: none;
  
  transition: .1s;

  img {
    margin: auto;
  }

  &.active {
    opacity: 1;
    pointer-events: unset;
  }
`
